import { IFrequency } from '../generated-types/frequency'
import { queryClient } from '../query-client'
import { apiConsts } from './apiConsts'
import { IPaginatedResult } from './paginated-result'
import { useDelete, useGet, usePost, usePut } from './reactQuery'

const baseUrl = (customerId: EntityId) => `customers/${customerId}/services`

export const endpoints = {
  getServices(customerId: EntityId) {
    return `${baseUrl(customerId)}`
  },
  getServicesByMooring(customerId: EntityId, mooringId: EntityId) {
    return `${baseUrl(customerId)}/get-services-with-mooring-assign-details/${mooringId}`
  },
  getService(customerId: EntityId, id: EntityId) {
    return `${baseUrl(customerId)}/${id}`
  },
  createService(customerId: EntityId) {
    return `${baseUrl(customerId)}`
  },
  updateService(customerId: EntityId, id: EntityId) {
    return `${baseUrl(customerId)}/${id}`
  },
  deleteService(customerId: EntityId) {
    return `${baseUrl(customerId)}`
  },
}

export const invalidateServiceCache = {
  getServices(customerId: EntityId) {
    queryClient.invalidateQueries(endpoints.getServices(customerId))
  },
  getService(customerId: EntityId, id: EntityId) {
    queryClient.invalidateQueries(endpoints.getService(customerId, id))
  },
  getServicesByMooring(customerId: EntityId, mooringId: EntityId) {
    queryClient.invalidateQueries(endpoints.getServicesByMooring(customerId, mooringId))
  },
}

export const useGetServices = (
  customerId: EntityId,
  serviceId: EntityId,
  page: number = apiConsts.Page,
  pageSize: number = apiConsts.Max,
) => useGet<IPaginatedResult<IFrequency>>(endpoints.getServices(customerId), { page, pageSize })

export const useGetServicesByMooring = (customerId: EntityId, mooringId: EntityId) =>
  useGet<IFrequency[]>(endpoints.getServicesByMooring(customerId, mooringId), undefined, { enabled: mooringId != 0 })

export const useGetService = (customerId: EntityId, id: EntityId) =>
  useGet<IFrequency>(endpoints.getService(customerId, id))

export const useAddService = (customerId: EntityId) =>
  usePost<IFrequency, IFrequency>(endpoints.createService(customerId))

export const useUpdateService = (customerId: EntityId, id: EntityId) =>
  usePut<IFrequency, IFrequency>(endpoints.updateService(customerId, id))

export const useDeleteService = (customerId: EntityId) => useDelete<IFrequency>(endpoints.deleteService(customerId))
